import { render, staticRenderFns } from "./TagResult.vue?vue&type=template&id=53e5875c&"
import script from "./TagResult.vue?vue&type=script&lang=js&"
export * from "./TagResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports